export default __webpack_public_path__ + "images/RZ.c4e9c78.png";